'use client'

import { ReactNode, useEffect } from 'react'
import { useMetadataStore } from '@/store'
import type { MetaData } from '@/types/meta'

type PropsType = {
  metadata: MetaData
  children: ReactNode
}

const MetadataProvider = ({ metadata, children }: PropsType) => {
  const setMetadata = useMetadataStore(state => state.setMetadata)

  useEffect(() => {
    setMetadata(metadata)
  }, [metadata, setMetadata])

  return children
}

export default MetadataProvider
